import { Component } from '@angular/core';


@Component({
  selector: 'lib-reset-password',
  imports: [],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css',
})
export class ResetPasswordComponent {}
